var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", "max-width": "600" },
      on: {
        input: function ($event) {
          return _vm.$emit("update:value", $event)
        },
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "modalCard" },
        [
          _c(
            "v-toolbar",
            { staticClass: "main", attrs: { flat: "", dark: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Update Summary")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "grey darken-2" },
                  on: { click: _vm.closeModal },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c("v-card-text", { staticClass: "pt-4" }, [
            _vm.response
              ? _c(
                  "div",
                  [
                    _vm.isLegacyResponse
                      ? [
                          _c(
                            "v-row",
                            { staticClass: "mb-2" },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-subtitle-1 font-weight-medium",
                                  },
                                  [
                                    _vm._v(
                                      " Order lines created: " +
                                        _vm._s(_vm.response.created || 0) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      : _vm.isDetailedResponse
                      ? [
                          _c(
                            "v-row",
                            { staticClass: "mb-2" },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-subtitle-1 font-weight-medium",
                                  },
                                  [
                                    _vm._v(
                                      " Total order lines created: " +
                                        _vm._s(
                                          _vm.response.total_orders_created
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                          (_vm.response.orders_created || []).length
                            ? _c(
                                "v-row",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 font-weight-medium mb-1",
                                        },
                                        [
                                          _vm._v(
                                            "Items with new suggested orders"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-simple-table",
                                        { attrs: { dense: "" } },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Item")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Description")]
                                              ),
                                            ]),
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.response.orders_created,
                                              function (item, i) {
                                                return _c(
                                                  "tr",
                                                  { key: "created-" + i },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.item_id)
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.item_desc || "—"
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          (_vm.response.components_adjusted || []).length
                            ? _c(
                                "v-row",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 font-weight-medium mb-1",
                                        },
                                        [
                                          _vm._v(
                                            "Component orders reduced (shipper generated)"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-simple-table",
                                        { attrs: { dense: "" } },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Item")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Description")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-right" },
                                                [_vm._v("Previous cases")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-right" },
                                                [_vm._v("New cases")]
                                              ),
                                            ]),
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.response.components_adjusted,
                                              function (item, i) {
                                                return _c(
                                                  "tr",
                                                  { key: "adj-" + i },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.item_id)
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.item_desc)
                                                      ),
                                                    ]),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.previous_cases
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.new_cases)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          (_vm.response.components_removed || []).length
                            ? _c(
                                "v-row",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 font-weight-medium mb-1",
                                        },
                                        [
                                          _vm._v(
                                            "Component orders removed (shipper covers)"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-simple-table",
                                        { attrs: { dense: "" } },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Item")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Description")]
                                              ),
                                            ]),
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.response.components_removed,
                                              function (item, i) {
                                                return _c(
                                                  "tr",
                                                  { key: "rem-" + i },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.item_id)
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.item_desc || "—"
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          (_vm.response.shippers_added || []).length
                            ? _c(
                                "v-row",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 font-weight-medium mb-1",
                                        },
                                        [_vm._v("Shipper items added")]
                                      ),
                                      _c(
                                        "v-simple-table",
                                        { attrs: { dense: "" } },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Item")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Description")]
                                              ),
                                            ]),
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.response.shippers_added,
                                              function (item, i) {
                                                return _c(
                                                  "tr",
                                                  { key: "add-" + i },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.item_id)
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.item_desc || "—"
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          (_vm.response.shippers_removed || []).length
                            ? _c(
                                "v-row",
                                { staticClass: "mb-3" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 font-weight-medium mb-1",
                                        },
                                        [_vm._v("Shipper items removed")]
                                      ),
                                      _c(
                                        "v-simple-table",
                                        { attrs: { dense: "" } },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Item")]
                                              ),
                                              _c(
                                                "th",
                                                { staticClass: "text-left" },
                                                [_vm._v("Description")]
                                              ),
                                            ]),
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.response.shippers_removed,
                                              function (item, i) {
                                                return _c(
                                                  "tr",
                                                  { key: "srem-" + i },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.item_id)
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.item_desc || "—"
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _c("div", { staticClass: "text-body-1" }, [
                  _vm._v(" No summary information available. "),
                ]),
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "text-capitalize font-weight-medium",
                  attrs: { color: "primary" },
                  on: { click: _vm.closeModal },
                },
                [_vm._v(" Close ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }